import { getSearch, requestSubmit, sendRequest } from "../api"
import { updateField, getField } from "vuex-map-fields"

const getDefaultState = () => {
    return {
        option_delivery_types : [
            { label : 'Pesanan Pelanggan', key : 'send'},
            { label : 'Pesanan Supplier', key : 'receive'}
        ],
        history_list: { data : []},
        history_search_params: getDefaultHistorySearchParamsState(),
        undelivered_list: [],
        undelivered_search_params: {
            delivery_type: '', // send | receive
            search_key: '',
            loading: false,
            filter_sort: []
        },
    }
}

const getFilterSortColumnDateName = (deliveryType) => {
    return deliveryType === 'send' ? 'sale.initial_date_time' : 'purchase.purchase_date'
}

const getDefaultHistorySearchParamsState = () => {
    return {
        filter_search_text : '',
        filter_delivery_type: '',
        loading : false,
        filter_sort : [{
            column : 'id',
            sort : 'desc',
            icon : ['fas', 'angle-down']
        }],
        filter_page : 1,
        filter_limit : 10
    }
}

export default ({
    namespaced: true, //
    // variable
    state: getDefaultState(),
    // must syncronous
    mutations: {
        RESET_STATE(state) {
            // Merge rather than replace so we don't lose observers
            // https://github.com/vuejs/vuex/issues/1118
            Object.assign(state, getDefaultState())
        },
        RESET_HISTORY_SEARCH_PARAMS(state) {
            state.history_search_params = getDefaultHistorySearchParamsState()
        },
        SET_UNDELIVERED_LOADING(state, payload) {
            state.undelivered_search_params.loading = payload
        },
        SET_UNDELIVERED_LIST(state, payload) {
            state.undelivered_list = payload
        },
        SET_HISTORY_LOADING(state, payload) {
            state.history_search_params.loading = payload
        },
        SET_HISTORY_LIST(state, payload) {
            state.history_list = payload
        },
        updateField

    },
    // can async
    actions: {
        loadHistoryList({commit, state, getters}, payload = { resetPage : false, deliveryType }) {
            if (payload.resetPage) {
                commit('updateField', { path : 'history_search_params.filter_page', value : 1})
            }
            if (payload.deliveryType) {
                commit('updateField', { path : 'history_search_params.filter_delivery_type', value : payload.deliveryType})
            } 

            // determine relation by deliveryType
            let within = ['stockDeliveryItems.product:id,name,code', 'stockDeliveryItems.unit:id,name', 'stockDeliveryItems.warehouse:id,name', 'senderable', 'pictures']
            if (state.history_search_params.filter_delivery_type == 'receive') {
                within.push('stockDeliveryItems.deliverable.purchase:id,stock_delivered_progress,stock_delivered_caption,invoice_code')
            } else if (state.history_search_params.filter_delivery_type == 'send') {
                within.push('stockDeliveryItems.deliverable.sale:id,invoice_code,memo,stock_delivered_progress,stock_delivered_caption,created_by_id')
                within.push('stockDeliveryItems.deliverable.sale.createdBy:id,name')
            }

            commit('SET_HISTORY_LOADING', true)
            return getSearch(
                {words: _.split(state.history_search_params.filter_search_text, ' '), fields : ['delivery_code', 'senderable>>name', 'stockDeliveryItems.warehouse>name', 'stockDeliveryItems>invoice_code', 'stockDeliveryItems.product>name']},
                [
                    [state.history_search_params.filter_delivery_type, '=', '', 'delivery_type']
                ],
                [],
                state.history_search_params.filter_sort,
                state.history_search_params.filter_page,
                state.history_search_params.filter_limit,
                within,
                ['pictures'],
                'stock-delivery/history',
                (response) => commit('SET_HISTORY_LIST', response),
                ()=>{},
                ()=>{commit('SET_HISTORY_LOADING', false)}
            )
        },
        async loadUndeliveredList({commit, state}, payload =  { deliveryType }) {
            if (payload.deliveryType) {
                commit('updateField', { path : 'undelivered_search_params.delivery_type', value : payload.deliveryType})
                // update filter sort
                commit('updateField', { path : 'undelivered_search_params.filter_sort', value : [{
                        column : getFilterSortColumnDateName(payload.deliveryType),
                        sort : 'desc',
                        icon : ['fas', 'angle-down']
                    }]
                })
            } 

            commit('SET_UNDELIVERED_LOADING', true)
            return await sendRequest('stock-delivery/undelivered', { 
                search_key : state.undelivered_search_params.search_key,
                delivery_type : state.undelivered_search_params.delivery_type,
                sort : JSON.stringify(state.undelivered_search_params.filter_sort)
            }, 'get', (fetchedList) => {
                commit('SET_UNDELIVERED_LIST', fetchedList)  
                commit('SET_UNDELIVERED_LOADING', false)
            })
        },
        resetForm({commit}) {
            commit('stockDeliveryForm/RESET_FORM', null, { root: true})
            commit('pictureForm/RESET_FORM', null, { root: true})
        },
        requestSaveStockDelivery({
            commit,
            rootState
        }) {
            let formData = {
                ...rootState.stockDeliveryForm,
                pictures: rootState.pictureForm.pictures,
                new_pictures: rootState.pictureForm.new_pictures.map(np => ({ caption: np.caption, file: np.file }))
            }
            return requestSubmit('stock-delivery', formData, commit, 'post', 
                (createdStockDelivery) => {
                    // nothing to do 
                }
            )
        }
    },
    // call variable with custom display
    getters: {
        getField,
        getSelectedDeliveryTypeLabel : state => listName => {
            // listName : historyList | undeliveredList
            let result = ''
            if (listName == 'historyList') {
                result = state.option_delivery_types.find(t => t.key == state.history_search_params.filter_delivery_type)
            } else if (listName = 'undeliveredList') {
                result = state.option_delivery_types.find(t => t.key == state.undelivered_search_params.delivery_type)
            }
            return result ? result.label : ''
        },
        getSenderableLabel : state => deliveryType => {

            return deliveryType == 'send' ? 'Pelanggan' : deliveryType == 'receive' ? 'Supplier' : '---'
        }
    },
    // modules
    modules: {

    }
})
